import React from "react";
// import img from "../assets/images/img35.png";
// import img1 from "../assets/images/img38.png";

const Research = () => {
  return (
    <>
      <section className="ax-ayurveda-sec py-5">
        <div className="container">
          {/* Heading */}
          <h2 className="ax-ayurveda-title text-center mb-5">
            Ayurveda Wisdom with Modern Science
          </h2>

          <div className="row align-items-center">
            {/* LEFT TEXT */}
            <div className="col-lg-6 col-md-12 ax-ayurveda-text">
              <p className="p-0 m-0">
                We follow a simple philosophy — trust nature. At{" "}
                <strong>TOP TREND AYURVEDA,</strong> we believe that nature
                holds the ultimate power to heal, restore, and rejuvenate the
                human body. We respect the deep-rooted knowledge passed down
                through generations and combine it with modern quality standards
                to create products that are both pure and effective. For us,
                Ayurveda is not just about treatment — it is about creating a
                balanced lifestyle where mind, body, and soul exist in harmony.
                Every ingredient we use is carefully selected based on authentic
                Ayurvedic principles, ensuring that it works in harmony with
                your body rather than against it. Our formulations are designed
                to restore balance, strengthen natural immunity, and promote
                long-term well-being instead of offering temporary relief.
              </p>

              <p>
                By integrating time-tested herbal knowledge with modern quality
                standards, we create solutions that are safe, natural, and
                aligned with the body’s natural healing process. This unique
                blend of <strong>heritage + science + innovation</strong>
                allows us to deliver products that truly represent the essence
                of Ayurveda.
              </p>
            </div>

            {/* RIGHT IMAGE */}
            <div className="col-lg-6 col-md-12 text-center ax-ayurveda-img-box">
              <img
                src="../../images/img35.png"
                alt="Ayurveda Preparation"
                className="img-fluid ax-ayurveda-img"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="ax-rd-sec py-5">
        <div className="container">
          {/* TITLE */}
          <h2 className="ax-rd-title mb-4">
            Ayurvedic Research and Development Center
          </h2>

          {/* CONTENT */}
          <div className="ax-rd-content">
            <p>
              The Research and Development (R&D) division at
              <strong> TOP TREND AYURVEDA </strong> is dedicated to preserving
              the essence of traditional Ayurvedic knowledge while integrating
              it with modern scientific practices. Our R&D center actively works
              across multiple areas of Ayurvedic research to develop safe,
              effective, and natural wellness solutions. Our research focuses on
              herbal formulation development, clinical validation,
              pharmacological studies, and modern quality assurance techniques.
              By combining time-tested Ayurvedic herbs with advanced research
              methodologies, we create products that meet today’s health
              standards while staying true to ancient traditions.
            </p>

            <p>
              Every formulation undergoes a structured process — from ingredient
              selection and purification to testing and final production. We
              ensure that each product maintains consistency, potency, and
              authenticity, delivering reliable results for overall health and
              well-being. Our R&D team continuously explores innovative
              approaches to improve Ayurvedic treatments for modern lifestyles.
              Through careful research, testing, and validation, we aim to
              provide solutions that support immunity, lifestyle balance, and
              long-term wellness. With a strong commitment to quality and
              purity,
              <strong> TOP TREND AYURVEDA </strong> ensures that every product
              is developed with precision, care, and deep respect for the
              principles of Ayurveda — offering a perfect balance between
              <strong> tradition and modern science.</strong>
            </p>
          </div>
        </div>
      </section>

      <section className="ax-rd-sec py-5">
        <div className="container">
          {/* TITLE */}
          <h2 className="ax-rd-title mb-4">Top Trend Ayurveda Herbal Garden</h2>

          {/* CONTENT */}
          <div className="ax-rd-content">
            <p>
              A Herbal Garden is a dedicated space where a variety of medicinal
              plants and Ayurvedic herbs are carefully cultivated and preserved.
              These gardens play an important role in maintaining the purity,
              authenticity, and effectiveness of natural ingredients used in
              herbal formulations. Each plant is grown under controlled
              conditions to retain its natural properties, ensuring maximum
              therapeutic value. Herbal gardens not only support sustainable and
              eco-friendly practices but also help in preserving traditional
              Ayurvedic knowledge. By sourcing herbs directly from such gardens,
              we ensure that every product is enriched with the true essence of
              nature and delivers safe, natural, and effective wellness
              solutions.
            </p>

            <p>
              A Herbal Garden is a natural sanctuary where medicinal plants and
              traditional Ayurvedic herbs are grown with care and respect for
              nature. It serves as the foundation of authentic herbal healing,
              ensuring that every ingredient used in wellness products is pure,
              fresh, and effective. By cultivating herbs in a controlled and
              sustainable environment, the natural potency and healing
              properties of each plant are preserved. Herbal gardens also
              reflect a deep connection with ancient Ayurvedic traditions,
              promoting a holistic approach to health and well-being. They play
              a vital role in delivering safe, chemical-free, and nature-based
              solutions for modern lifestyles.
            </p>
          </div>
        </div>
      </section>

      <section className="ax-ayurveda-sec py-5">
        <div className="container">
          {/* Heading */}
          <h2 className="ax-ayurveda-title text-center mb-5">
            Pioneers in Herbal Innovation and Wellness Solutions
          </h2>

          <div className="row align-items-center">
            {/* RIGHT IMAGE */}
            <div className="col-lg-6 col-md-12 text-center ax-ayurveda-img-box">
              <img
                src="../../images/img38.png"
                alt="Ayurveda Preparation"
                className="img-fluid ax-ayurveda-img"
              />
            </div>

            {/* LEFT TEXT */}
            <div className="col-lg-6 col-md-12 ax-ayurveda-text mt-2 mt-lg-0">
              <p>
                At <strong>TOP TREND AYURVEDA,</strong> being pioneers in herbal
                innovation and wellness solutions means continuously striving to
                enhance the power of nature through modern advancements. We
                combine traditional Ayurvedic knowledge with innovative research
                to develop products that are both effective and safe. Our focus
                is on creating natural solutions that support overall health,
                improve well-being, and fit seamlessly into modern lifestyles.
                By exploring new techniques while staying rooted in
                authenticity, we aim to set new standards in herbal care and
                bring trusted wellness solutions to people everywhere.
              </p>

              <p>
                At TOP TREND AYURVEDA, we take pride in being pioneers in herbal
                innovation and wellness solutions by bringing together the
                richness of Ayurveda and the precision of modern science. Our
                approach focuses on developing advanced herbal formulations that
                are rooted in tradition yet designed for today’s lifestyle. We
                continuously explore new ways to enhance the effectiveness of
                natural ingredients while maintaining their purity and
                authenticity. Through innovation, research, and a deep
                understanding of holistic health, we aim to provide reliable,
                safe, and nature-based solutions that promote long-term wellness
                and a balanced life.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Research;
